module.exports = __webpack_public_path__ + "static/chris-bell-profile-square-a92352deb040f49be057908fb92bb654.jpg";